import styles from '../../GlobalSSOBanner.module.css'
import type {SsoOrganization} from '../../types'

export interface DismissalSummaryProps {
  ssoOrgs: SsoOrganization[]
}

export function DismissalSummary({ssoOrgs}: DismissalSummaryProps) {
  if (ssoOrgs.length === 1) {
    const org = ssoOrgs[0]
    return <p>You are dismissing single sign-on prompts for the {org?.name} organization on this device.</p>
  }

  return (
    <>
      <p>You are dismissing single sign-on prompts for the following organizations on this device:</p>
      <ul className={styles.dismissedOrgList}>
        {ssoOrgs.map(org => (
          <li key={org.id}>{org.name}</li>
        ))}
      </ul>
    </>
  )
}

try{ DismissalSummary.displayName ||= 'DismissalSummary' } catch {}